import repo from 'service/repository';
import { PATH } from 'config';

const welcomeList = ['intro', 'gasStation', 'parkinglots', 'onStreetParking'];

const onBoardingAddPlateNumberData = {
  promises: [repo.fetchUserInfo, repo.fetchLicensePlates, repo.fetchBootstraps],
  path: PATH.USER_BIND_CARD,
};

const mainFeaturesList = ['refueling', 'parking', 'on-street-parking'];

const bottomTabList = ['main', 'maps', 'orders', 'coins'];

const ordersList = [
  { key: 'refueling', value: '加油站' },
  { key: 'parking', value: '停車場' },
  { key: 'on_street_parking', value: '路邊停車' },
];

const configData = {
  welcomeList,
  onBoardingAddPlateNumberData,
  mainFeaturesList,
  bottomTabList,
  ordersList,
};

export default configData;
